import { trace } from 'rytm-helpers';

export const initScrollTo = () => {
  // add click event to document
  document.addEventListener('click', onDocumentClick);
}

/**
 * Event handlers
 */
const onDocumentClick = (e) => {
  const scrollLink = e.target.closest('[data-scroll-to]');
  if (scrollLink) {
    e.preventDefault();
    const target = scrollLink.getAttribute('href');
    scrollTo(target);
  }
}
// scroll to target
const scrollTo = (target) => {
  const targetEl = document.querySelector(target);
  if (targetEl) {
    targetEl.scrollIntoView({ behavior: 'smooth' });
  }
}